import React from 'react';
import '../App.css';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button
} from '@material-ui/core';
import { useRecoilState } from 'recoil';
import { mainBlueColor } from '../GlobalState';
import { useHistory } from 'react-router-dom';
import { currencyStyle } from '../utils/common';

type GraphStatus = {
  id: number;
  progress: string;
  name: string;
  start_date: string;
  end_date: string;
  planned_sales: number;
  planned_cost: number;
  planned_gross_profit: number;
  planned_gross_profit_rate: number;
  actual_sales: number;
  actual_cost: number;
  actual_gross_profit: number;
  actual_gross_profit_rate: number;
};

type GraphStatuses = {
  currency: number;
  graphStatus: GraphStatus[];
};

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

function createData(
  id: number,
  progress: string,
  name: string,
  start_date: string | number,
  end_date: string | number,
  planned_sales: number,
  planned_cost: number,
  planned_gross_profit: number,
  planned_gross_profit_rate: string | number,
  actual_sales: number,
  actual_cost: number,
  actual_gross_profit: number,
  actual_gross_profit_rate: string | number
) {
  return {
    id,
    progress,
    name,
    start_date,
    end_date,
    planned_sales,
    planned_cost,
    planned_gross_profit,
    planned_gross_profit_rate,
    actual_sales,
    actual_cost,
    actual_gross_profit,
    actual_gross_profit_rate
  };
}

const IndividualConstructionable: React.FC<GraphStatuses> = graphStatuses => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const history = useHistory();
  const matches = useMediaQuery('(min-width:600px)');
  const matches2 = useMediaQuery('(min-width:900px)');

  const rows = graphStatuses.graphStatus.map((output, index) => {
    return createData(
      output.id,
      output.progress,
      output.name,
      output.start_date,
      output.end_date,
      output.planned_sales,
      output.planned_cost,
      output.planned_gross_profit,
      output.planned_gross_profit_rate,
      output.actual_sales,
      output.actual_cost,
      output.actual_gross_profit,
      output.actual_gross_profit_rate
    );
  });

  const useStyles = makeStyles({
    main: {
      minWidth: 700
    },
    table: {
      backgroundColor: mainColor,
      color: '#FFFFFF',
      fontSize: 16
    },
    table1: {
      color: '#000000',
      fontSize: 16
    }
  });

  const classes = useStyles();

  return (
    <>
      <div className='responsive-container-main-table'>
        <TableContainer component={Paper}>
          <Table className={classes.main} aria-label='customized table'>
            <TableHead>
              <TableRow>
                <StyledTableCell className={classes.table} align='center'>
                  工事名
                </StyledTableCell>
                <StyledTableCell className={classes.table} align='center'>
                  進行状況
                  {/* 担当者名 */}
                </StyledTableCell>
                <StyledTableCell className={classes.table} align='center'>
                  着工日
                </StyledTableCell>
                <StyledTableCell className={classes.table} align='center'>
                  竣工日
                </StyledTableCell>
                <StyledTableCell className={classes.table} align='center'>
                  計画売上
                </StyledTableCell>
                <StyledTableCell className={classes.table} align='center'>
                  計画原価
                </StyledTableCell>
                <StyledTableCell className={classes.table} align='center'>
                  計画粗利
                </StyledTableCell>
                <StyledTableCell className={classes.table} align='center'>
                  計画粗利率
                </StyledTableCell>
                <StyledTableCell className={classes.table} align='center'>
                  売上実績
                </StyledTableCell>
                <StyledTableCell className={classes.table} align='center'>
                  原価実績
                </StyledTableCell>
                <StyledTableCell className={classes.table} align='center'>
                  粗利実績
                </StyledTableCell>
                <StyledTableCell
                  style={{ minWidth: 70 }}
                  className={classes.table}
                  align='center'
                >
                  粗利率実績
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(row => (
                <StyledTableRow
                  className='click_table_row'
                  onClick={() => {
                    history.push(`/constructions/${row.id}/edit`, {
                      state: row.id
                    });
                  }}
                  key={row.name}
                >
                  <StyledTableCell className={classes.table1} align='center'>
                    {row.name}
                  </StyledTableCell>
                  <StyledTableCell className={classes.table1} align='center'>
                    {row.progress}
                  </StyledTableCell>
                  <StyledTableCell className={classes.table1} align='center'>
                    {row.start_date}
                  </StyledTableCell>
                  <StyledTableCell className={classes.table1} align='center'>
                    {row.end_date}
                  </StyledTableCell>
                  <StyledTableCell className={classes.table1} align='right'>
                    {currencyStyle(row.planned_sales, graphStatuses.currency)}
                  </StyledTableCell>
                  <StyledTableCell className={classes.table1} align='right'>
                    {currencyStyle(row.planned_cost, graphStatuses.currency)}
                  </StyledTableCell>
                  <StyledTableCell className={classes.table1} align='right'>
                    {currencyStyle(
                      row.planned_gross_profit,
                      graphStatuses.currency
                    )}
                  </StyledTableCell>
                  <StyledTableCell className={classes.table1} align='right'>
                    {row.planned_gross_profit_rate} %
                  </StyledTableCell>
                  <StyledTableCell className={classes.table1} align='right'>
                    {currencyStyle(row.actual_sales, graphStatuses.currency)}
                  </StyledTableCell>
                  <StyledTableCell className={classes.table1} align='right'>
                    {currencyStyle(row.actual_cost, graphStatuses.currency)}
                  </StyledTableCell>
                  <StyledTableCell className={classes.table1} align='right'>
                    {currencyStyle(
                      row.actual_gross_profit,
                      graphStatuses.currency
                    )}
                  </StyledTableCell>
                  <StyledTableCell className={classes.table1} align='right'>
                    {row.actual_gross_profit_rate} %
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      {/* <div style={{ backgroundColor: "#F5F5F5", height: 80 }} /> */}
      <div style={{ height: 15, backgroundColor: '#F5F5F5' }} />
      <div
        style={{
          marginBottom: !matches2 ? 10 : 0,
          fontSize: !matches ? 20 : 24,
          fontWeight: 'bold',
          padding: !matches ? 15 : 20
        }}
      >
        工事別実績
      </div>
    </>
  );
};
export default IndividualConstructionable;
